import { render, staticRenderFns } from "./photo-name.vue?vue&type=template&id=066ce94d&"
import script from "./photo-name.vue?vue&type=script&lang=js&"
export * from "./photo-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports